var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"wrapperRef",staticClass:"tw-z-10",class:{ 'tw-h-72': _vm.isSticky },style:(_vm.stickyStyle)},[_c('PanelBuilder',{attrs:{"product-id":_vm.productId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }